import { render, staticRenderFns } from "./exchangeGoods.vue?vue&type=template&id=642b9cf2&scoped=true&"
import script from "./exchangeGoods.vue?vue&type=script&lang=js&"
export * from "./exchangeGoods.vue?vue&type=script&lang=js&"
import style0 from "./exchangeGoods.vue?vue&type=style&index=0&id=642b9cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b9cf2",
  null
  
)

component.options.__file = "exchangeGoods.vue"
export default component.exports